import React from 'react';
import UserMenu from './UserMenu';
import { useCommonSelector } from '@wajeez-web/stores/common';
const SidebarHeader = ({ withSettings = true }: { withSettings?: boolean }) => {
  const { logo } = useCommonSelector((state) => state.common.settings);
  return (
    <div className="flex items-center w-full py-4 px-2  ">
      <div className="flex items-center justify-center  ">
        <img
          src={logo || 'assets/images/logo.png'}
          alt="wajeez logo"
          className="w-8 xl:w-10 lg:w-8 md:w-8 h-auto fill-current"
        />
      </div>
      <div className="flex items-center ms-auto">
        <div className="relative  flex">
          <UserMenu withSettings={withSettings} />
        </div>
      </div>
    </div>
  );
};

export default SidebarHeader;
